'use client';
import { useState } from 'react';

import useHash from '@/hooks/useHash';

import { BlockReference } from '@/components/cms/types/block';

import { LeadPopUp } from './LeadPopUpForm';
import { LeadPopUpFormError } from './LeadPopUpFormError';
import { LeadPopUpFormSuccess } from './LeadPopUpFormSuccess';
import { CaptureUserDetailsProps } from '../GatedContent/types';
import { Modal } from '../../atoms/Modal';

export type LeadPopUpModalActions = 'form_page' | 'success_page' | 'error_page';

export type LeadPopUpProps = {
  urlHash: string;
};

export function LeadPopUpModal({
  lead_pop_up,
  urlHash,
}: {
  lead_pop_up?: BlockReference<CaptureUserDetailsProps>;
} & LeadPopUpProps) {
  const [step, setStep] = useState<LeadPopUpModalActions>('form_page');
  const { hash, clearHash } = useHash();

  function handleChange(open: boolean) {
    clearHash();
    if (!open) {
      clearHash();
    }
  }

  function handleClose() {
    clearHash();
    setStep('form_page');
  }

  function handleSuccess() {
    setStep('success_page');
    setTimeout(() => {
      clearHash();
    }, 15000);
  }

  function handleTryAgain() {
    setStep('form_page');
  }

  function handleError() {
    setStep('error_page');
  }

  return (
    <div data-tracker-section='lead-pop-up'>
      <Modal
        isOpen={hash === urlHash}
        onClose={() => handleChange(false)}
        closeOnOutsideClick={true}
        hasClose={true}
        classNames={{
          close: 'text-gray-500',
          closeCross: 'h-6 w-6',
          modal: 'px-5 py-8 m:p-[60px] mx-5 m:mx-0 rounded max-w-[720px]',
          root: 'my-12 m:my-0 items-start m:items-center',
        }}
      >
        {step === 'form_page' && lead_pop_up?.data?.attributes && (
          <div>
            <LeadPopUp
              {...lead_pop_up.data.attributes}
              onError={handleError}
              onSuccess={handleSuccess}
            />
          </div>
        )}
        {step === 'success_page' && (
          <LeadPopUpFormSuccess onClose={handleClose} />
        )}
        {step === 'error_page' && (
          <LeadPopUpFormError onSubmit={handleTryAgain} />
        )}
      </Modal>
    </div>
  );
}
